import Link from '@/components/Link'
import { useIntercom } from 'react-use-intercom';

export default function Footer() {
  const { showNewMessages } = useIntercom();
  return (
    <footer className="bg-gray-900 py-8">
      <div className="container">
        <div className="grid grid-cols-3 lg:grid-cols-5 lg:dark:grid-cols-3 gap-8 border-b border-white border-opacity-10 pb-8">
          <div>
            <p className="font-medium mb-4 text-white">DuelArena</p>
            <div className="grid gap-1">
              <FooterLink label="Home" href="/" />
              {/* <FooterLink label="Rules" href="/" /> */}
              <FooterLink label="Live" href="/arena" />
            </div>
          </div>
          <div>
            <p className="font-medium mb-4 text-white">Staking</p>
            <div className="grid gap-1">
              {/* <FooterLink label="Games" href="/" /> */}
              {/* <FooterLink label="VIP Club" href="/" /> */}
              {/* <FooterLink label="Promotions" href="/" /> */}
              <FooterLink label="Leaderboards" href="/leaderboard" />
            </div>
          </div>
          <div>
            <p className="font-medium mb-4 text-white">Support</p>
            <div className="grid gap-1">
              {/* <FooterLink label="Fairness" href="/" /> */}
              {/* <FooterLink label="Affiliates" href="/" /> */}
              {/* <FooterLink label="Live Support" href="/" /> */}
              <div className="flex">
                <button onClick={() => showNewMessages()} className="text-gray-300 hover:text-gray-200 text-sm font-medium">
                  <span>Live Support</span>
                </button>
              </div>
            </div>
          </div>
          <div>
            <p className="font-medium mb-4 text-white">Community</p>
            <div className="grid gap-1">
              {/* <FooterLink label="News" href="/" /> */}
              {/* <FooterLink label="Discord" href="/" /> */}
              {/* <FooterLink external label="Twitter" href="/" /> */}
              <div className="flex">
                <a href="https://discord.gg/duel-arena" target="__blank" className="text-gray-300 hover:text-gray-200 text-sm font-medium">
                  <span>Discord</span>
                </a>
              </div>
            </div>
          </div>
          <div>
            <p className="font-medium mb-4 text-white">About Us</p>
            <div className="grid gap-1">
              <FooterLink label="Privacy Policy" href="/privacy" />
              <FooterLink label="Terms of Service" href="/tos" />
            </div>
          </div>
        </div>

        <div className="flex flex-col justify-center items-center pt-8">
          <Link to="/"><span className="text-2xl font-bold tracking-tight text-white">Duels</span></Link>
          <p className="text-gray-300 text-sm text-center">© {new Date().getFullYear()} Duels.gg | All Rights Reserved.</p>
          {/* <p className="text-gray-300 text-xs text-center mt-8">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptatum enim voluptates placeat labore tempore ipsam.</p> */}
          <div className="flex justify-center text-sm mt-8">
            <p className="text-gray-300 flex space-x-1">
              <span>Support</span>
              <a href="mailto:support@duels.gg">
                <span className="text-white block">support@duels.gg</span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

const FooterLink = ({ label, href, passHref = false, external = false }) => {
  return (
    <div className="flex">
      <Link className="text-gray-300 hover:text-gray-200 text-sm font-medium" to={href} target={external ? '__blank' : ''}>
        <span>{label}</span>
      </Link>
    </div>
  )
}